import type { ResourceDataFileResourceReadApi } from '@ingenico/api-sdk-device-management-private-v2';
import { toString } from 'lodash-es';
import { mapMimeTypeToIconCategory } from '../../../utils/resourceIconCategory.util';
import type { ResourceListItemFront } from '../../models/resources.model';
import { toIsoStringIfDate } from '../utils/date.utils';

export function mapEditResourceResponse(response: ResourceDataFileResourceReadApi): ResourceListItemFront {
  return {
    id: toString(response.id),
    name: toString(response.name),
    description: toString(response.description),
    creationDate: toIsoStringIfDate(response.creationDate),
    organizationName: '',
    organizationId: toString(response.owner?.id),
    createdBy: toString(response.createdBy),
    filename: response.artifact.fileName,
    extension: response.artifact.extension.toUpperCase(),
    mimeType: response.artifact.mimeType ?? '',
    sizeBytes: response.artifact.size,
    iconCategory: mapMimeTypeToIconCategory(response.artifact.mimeType),
  };
}
